<template>
  <div>
    <div class="hm-dashboard__top">
      <div class="hm-dashboard__header">
        <h1 class="hm-dashboard__title">
          Dashboard
          <span class="hm-dashboard__title-date">{{ fmtDate() }}</span>
        </h1>
        <HMSearch id="list-search" v-model="query" width="300" />
      </div>
      <HMButton
        @click.native="onShowListHouseModal"
        background="linear-gradient(180deg, #DAEDFD 0%, #D2E7FB 100%)" color="#499DAE"
      >
        <PrintIcon/>
        <span>Print the House List</span>
      </HMButton>
    </div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <div class="hm-dashboard__controls">
        <button
          v-for="tab in tabs"
          :key="tab.label"
          :class="{
          'hm-dashboard__control--disabled': rooms[tab.status].length === 0,
          'hm-dashboard__control--active': tab.status === current_rooms_status
        }"
          class="hm-dashboard__control"
          role="tab"
          @click="current_rooms_status = tab.status"
        >
        <span class="hm-dashboard__control-top">
          <component :is="tab.icon" aria-hidden="true"/>
          <span :style="{color: tab.color}" class="hm-dashboard__control-text">{{ tab.label }}</span>
        </span>
        </button>
      </div>
      <div v-if="filteredRooms.length" class="hm-dashboard__line">
        <div class="hm-dashboard__grid" style="margin-bottom: 18px">
          <span class="hm-dashboard__grid-head">Group Name</span>
          <span class="hm-dashboard__grid-head">Room</span>
          <span class="hm-dashboard__grid-head">Stay </span>
          <span class="hm-dashboard__grid-head">Guests</span>
        </div>
        <div></div>
        <div></div>
      </div>
      <div v-if="filteredRooms.length" v-search-highlight="{query, classes: ['hm-dashboard__highlighted']}">
        <div v-for="room in filteredRooms" :key="room.id" class="hm-dashboard__row">
          <HMDashboardLine @onShowModal="onShowModal" :currentRoomsStatus="current_rooms_status" :room="room" :key="room.id" />
        </div>
      </div>
      <HMSlug v-else>
        <template #img><img src="@/assets/img/hm-bed.png" alt="Bed"></template>
        <template #title>No rooms found</template>
        <template #text>We couldn’t find any results matching your search. Please check your query and try again.</template>
      </HMSlug>
    </template>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="400"
      name="house-list"
    >
      <div class="popup-new">
        <button class="popup-new__close" type="button" @click="$modal.hide('house-list')"></button>
        <div class="popup-new__title">House List</div>
        <div class="popup-new__body">
          <form @submit.prevent="onCheckForm">
            <app-form-field v-if="!is_hotel_reception" label="Property" class="family" required :marginBottom="20">
              <app-select
                v-model="form_house.property"
                :options="property_options"
                :reduce="item => item.code"
                :clearable="false"
                placeholder="Property"
                class="family"
                :error="$v.form_house.property.$error"
              />
              <template #error>
                <div v-if="$v.form_house.property.$dirty && !$v.form_house.property.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field label="Date" class="family" required :marginBottom="20">
              <app-date-picker
                v-model="form_house.date"
                class="family"
                placeholder="DD / MM / YY"
                :clearable="false"
                :disabled-date="disableSpecificDates"
                :error="$v.form_house.date.$error"
              />
              <template #error>
                <div v-if="$v.form_house.date.$dirty && !$v.form_house.date.required">Required field</div>
              </template>
            </app-form-field>
            <app-cells :indent="false" position="center">
              <HMButton :loading="isSubmittingHouseForm"><span>Get</span></HMButton>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="480"
      name="confirmation"
    >
      <div class="popup-new">
        <button class="popup-new__close" type="button" @click="$modal.hide('confirmation')"></button>
        <div class="popup-new__title popup-new__title--mb-30 ">
          {{ current_rooms_status === 'check_in_today' ? 'Check-In' : 'Check-Out' }} Confirmation
        </div>
        <div v-if="currentRoom" class="popup-new__body">
          <div class="popup-new__keyval">
            <span>Group Name:</span>
            <span>{{ currentRoom.reservation.group_name }}</span>
          </div>
          <HMRoomsItem
            :room="currentRoom"
          />
          <div v-if="currentRoom.guests.length" class="popup-new__keyval">
            <span>Guests:</span>
          </div>
          <div v-for="guest in currentRoom.guests" :key="guest.id" class="hm-dashboard__content-guest hm-dashboard__content-guest--mb">
              <span class="hm-dashboard__gender">
                <MaleIcon v-if="guest.gender && guest.gender.code === 'male'"/>
                <FemaleIcon v-else-if="guest.gender && guest.gender.code === 'female'"/>
              </span>
            <span
              :class="{ 'hm-dashboard__flag--empty': !(guest.citizenship && guest.citizenship.code) }"
              :title="guest.citizenship && guest.citizenship.name ? guest.citizenship.name : ''"
              class="hm-dashboard__flag"
            >
                <span
                  v-if="guest.citizenship && guest.citizenship.code"
                  :class="`fflag ff-md fflag-${guest.citizenship.code}`"
                ></span>
              </span>
            <span class="hm-dashboard__guest-name">
                <span>
                  {{
                    (
                      guest.gender && guest.gender.greeting
                    ) ? guest.gender.greeting : ''
                  }} {{
                    guest.full_name || (
                      (
                        guest.first_name || ''
                      ) + ' ' + (
                        guest.last_name || ''
                      )
                    )
                  }}
                </span>
          </span>
          </div>

        </div>
        <app-cells :indent="false" position="center" marginTop="30px">
          <HMButton @click.native="onPatchRoom(currentRoom, current_rooms_status === 'check_in_today' ? 'checked_in' : 'checked_out')" :loading="isPatchRoomLoading">
            <component :is="current_rooms_status === 'check_in_today' ? 'CheckInBtn' : 'CheckOutBtnGreen'" aria-hidden="true"/>
            <span>{{ current_rooms_status === 'check_in_today' ? 'Check In' : 'Check Out' }}</span>
          </HMButton>
        </app-cells>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getHotelManagementReservationsRooms,
  patchHotelManagementReservationsRooms,
  getHotelManagementPropertiesV2,
  getHotelManagementExportHouseList
} from '@/http'
import HMSearch from '@/views/hotel-management/reservations/components/HMSearch.vue'
import HMDashboardLine from '@/views/hotel-management/reservations/components/HMDashboardLine.vue'
import CheckIn from '@/views/hotel-management/reservations/detail/icons/CheckIn.vue'
import CheckOut from '@/views/hotel-management/reservations/detail/icons/CheckOut.vue'
import InHouseIcon from '@/views/hotel-management/reservations/detail/icons/InHouseIcon.vue'
import HMSlug from '@/views/hotel-management/reservations/components/HMSlug.vue'
import FemaleIcon from '@/views/hotel-management/reservations/detail/icons/FemaleIcon.vue'
import HMRoomsItem from '@/views/hotel-management/reservations/components/HMRoomsItem.vue'
import MaleIcon from '@/views/hotel-management/reservations/detail/icons/MaleIcon.vue'
import HMButton from '@/views/hotel-management/reservations/components/HMButton.vue'
import CheckInBtn from '@/views/hotel-management/reservations/detail/icons/CheckInBtn.vue'
import CheckOutBtnGreen from '@/views/hotel-management/reservations/detail/icons/CheckOutBtnGreen.vue'
import { required, requiredIf } from 'vuelidate/lib/validators'
import PrintIcon from '@/views/hotel-management/reservations/detail/icons/PrintIcon.vue'

export default {
  name: 'HotelManagementReservationsDashboard',
  components: {
    PrintIcon,
    HMButton,
    MaleIcon,
    FemaleIcon,
    HMRoomsItem,
    HMSlug,
    HMDashboardLine,
    HMSearch,
    InHouseIcon,
    CheckOut,
    CheckIn,
    CheckInBtn,
    CheckOutBtnGreen
  },
  data() {
    return {
      page_loaded: false,
      query: '',
      tabs: [
        {label: 'Checking In', icon: CheckIn, status: 'check_in_today', color: '#76A9B4'},
        {label: 'Checking Out', icon: CheckOut, status: 'check_out_today', color: '#DA8C7B'},
        {label: 'In House', icon: InHouseIcon, status: 'in_house', color: '#89BD7B'},
      ],
      rooms: {
        check_in_today: [],
        check_out_today: [],
        in_house: [],
      },
      current_rooms_status: 'check_in_today',
      currentRoom: null,
      isPatchRoomLoading: false,
      isSubmittingHouseForm: false,
      property_options: [],
      form_house: {},
    }
  },
  validations: {
    form_house: {
      property: {
        required: requiredIf(function() {
          return !this.is_hotel_reception
        })
      },
      date: {required},
    },
  },
  created() {
    getHotelManagementPropertiesV2().then(response => { this.property_options = response.data })
    this.fetchRooms()
  },
  computed: {
    filteredRooms() {
      return this.rooms[this.current_rooms_status].filter(item => {
        return item.room?.room_name.toLowerCase().includes(this.query.toLowerCase()) ||
          item.reservation.group_name.toLowerCase().includes(this.query.toLowerCase()) ||
          item.guests.some(guest => guest.full_name.toLowerCase().includes(this.query.toLowerCase()))
      })
    },
    is_hotel_reception() {
      return this.$store.state.userGroups.map(item => item.code).includes('hotel_reception')
    },
  },
  // watch: {
  //   rooms: {
  //     handler() {
  //       if (!this.rooms.check_in_today.length) {
  //         this.current_rooms_status = 'check_out_today'
  //         if (!this.rooms.check_out_today.length) this.current_rooms_status = 'in_house'
  //       }
  //     },
  //     deep: true,
  //   }
  // },
  methods: {
    onCheckForm() {
      this.$v.form_house.$touch()
      if (this.$v.form_house.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendFormHouse()
      }
    },
    sendFormHouse() {
      this.isSubmittingHouseForm = true
      const data = {...this.form_house}
      if (this.is_hotel_reception) data.property = this.$store.state.userData.hotel_property.code
      getHotelManagementExportHouseList(data)
        .finally(() => { this.isSubmittingHouseForm = false })
        .then(response => {
          this.$modal.hide('house-list')
          window.open(response.data)
        })
    },
    onShowListHouseModal() {
      this.form_house = {}
      this.$v.form_house.$reset()
      this.$modal.show('house-list')
    },
    disableSpecificDates(date) {
      const today = new Date()
      const weekForward = new Date()
      today.setHours(0, 0, 0, 0)
      weekForward.setHours(0, 0, 0, 0)
      weekForward.setDate(weekForward.getDate() + 7)
      return !(date >= today && date <= weekForward)
    },
    fetchRooms() {
      Promise.all([
        getHotelManagementReservationsRooms({frontdesk_category: 'check_in_today'}),
        getHotelManagementReservationsRooms({frontdesk_category: 'check_out_today'}),
        getHotelManagementReservationsRooms({frontdesk_category: 'in_house'}),
      ])
        .then(res => {
          this.rooms.check_in_today = res[0].data
          this.rooms.check_out_today = res[1].data
          this.rooms.in_house = res[2].data
          if (!this.rooms.check_in_today.length) {
            this.current_rooms_status = 'check_out_today'
            if (!this.rooms.check_out_today.length) this.current_rooms_status = 'in_house'
          }
          this.page_loaded = true
        })
    },
    onPatchRoom(data, status) {
      this.isPatchRoomLoading = true
      patchHotelManagementReservationsRooms(data.id, {status})
        .finally(() => { this.isPatchRoomLoading = false })
        .then(() => {
          this.fetchRooms()
          this.$modal.hide('confirmation')
        })
    },
    onShowModal(data) {
      this.currentRoom = data
      this.$modal.show('confirmation')
    },
    fmtDate() {
      const d = new Date()
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${d.getDate()} ${months[d.getMonth()]}, ${d.getFullYear()}`
    },
  },
  directives: {
    searchHighlight: {
      bind(el) {
        // хранилище состояния
        el.__hl__ = { lastQuery: '', selectors: null, highlighting: false }

        // utils
        const escapeRegExp = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        const debounce = (fn, ms = 60) => { let t = undefined; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms) } }
        const normalizeSelectors = (val) => {
          if (!val) return null
          let list = Array.isArray(val) ? val : String(val).split(',')
          list = list.map(s => s.trim()).filter(Boolean)
          // если передали имена классов без точки — добавим точку
          return list.map(s => (s.startsWith('.') || /[#>\[\]\s:]/.test(s) ? s : `.${s}`))
        }

        const setOptsFromBinding = (binding) => {
          if (typeof binding.value === 'string') {
            el.__hl__.lastQuery = binding.value
            el.__hl__.selectors = null
          } else if (binding.value && typeof binding.value === 'object') {
            el.__hl__.lastQuery = binding.value.query || ''
            el.__hl__.selectors = normalizeSelectors(binding.value.classes || binding.value.within || binding.value.targets)
          } else {
            el.__hl__.lastQuery = ''
            el.__hl__.selectors = null
          }
        }

        // очистка подсветки
        el.__clearHighlights__ = () => {
          const marks = el.querySelectorAll('mark.hm-dashboard__hit')
          marks.forEach(m => {
            const text = document.createTextNode(m.textContent)
            m.parentNode.replaceChild(text, m)
            text.parentNode.normalize()
          })
        }

        const isInTargets = (node) => {
          const sels = el.__hl__.selectors
          if (!sels || !sels.length) return true
          const p = node.parentElement
          if (!p) return false
          // ищем ближайший предок, удовлетворяющий любому из селекторов, внутри текущего контейнера
          return sels.some(sel => {
            const host = p.closest(sel)
            return host && el.contains(host)
          })
        }

        // подсветка
        el.__applyHighlights__ = () => {
          const q = (el.__hl__.lastQuery || '').trim()
          el.__clearHighlights__()
          if (!q) return

          const re = new RegExp(escapeRegExp(q), 'gi')

          const walker = document.createTreeWalker(
            el,
            NodeFilter.SHOW_TEXT,
            {
              acceptNode(node) {
                if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT
                const p = node.parentElement
                if (!p) return NodeFilter.FILTER_REJECT
                if (p.closest('mark.hm-dashboard__hit')) return NodeFilter.FILTER_REJECT
                if (p.isContentEditable) return NodeFilter.FILTER_REJECT
                if (/(SCRIPT|STYLE|NOSCRIPT|TEMPLATE|TEXTAREA)/.test(p.tagName)) return NodeFilter.FILTER_REJECT
                if (!isInTargets(node)) return NodeFilter.FILTER_REJECT
                return NodeFilter.FILTER_ACCEPT
              }
            },
            false
          )

          const textNodes = []
          while (walker.nextNode()) textNodes.push(walker.currentNode)

          el.__hl__.highlighting = true
          try {
            textNodes.forEach(node => {
              const text = node.nodeValue
              let m = undefined; const ranges = []
              re.lastIndex = 0
              while ((m = re.exec(text)) !== null) ranges.push([m.index, m.index + m[0].length])
              for (let i = ranges.length - 1; i >= 0; i--) {
                const [start, end] = ranges[i]
                const range = document.createRange()
                range.setStart(node, start)
                range.setEnd(node, end)
                const mark = document.createElement('mark')
                mark.className = 'hm-dashboard__hit'
                range.surroundContents(mark)
              }
            })
          } finally {
            el.__hl__.highlighting = false
          }
        }

        el.__rehighlight__ = debounce(() => el.__applyHighlights__(), 60)

        // observer для динамики
        el.__observer__ = new MutationObserver(muts => {
          if (el.__hl__.highlighting) return
          if (muts.some(m => m.type === 'childList' || m.type === 'characterData')) el.__rehighlight__()
        })
        el.__observer__.observe(el, { subtree: true, childList: true, characterData: true })

        // первичная инициализация опций
        setOptsFromBinding(el.__initialBinding__ || {})
        // примечание: el.__initialBinding__ будет установлен в 'inserted'
      },

      inserted(el, binding) {
        // фикс для корректной инициализации после вставки в DOM
        el.__initialBinding__ = binding
        // перечитать опции и подсветить
        if (el.__rehighlight__) {
          // обновим конфиг из binding
          if (typeof binding.value === 'string') {
            el.__hl__.lastQuery = binding.value
            el.__hl__.selectors = null
          } else if (binding.value && typeof binding.value === 'object') {
            el.__hl__.lastQuery = binding.value.query || ''
            const normalize = (val) => {
              if (!val) return null
              let list = Array.isArray(val) ? val : String(val).split(',')
              list = list.map(s => s.trim()).filter(Boolean)
              return list.map(s => (s.startsWith('.') || /[#>\[\]\s:]/.test(s) ? s : `.${s}`))
            }
            el.__hl__.selectors = normalize(binding.value.classes || binding.value.within || binding.value.targets)
          }
          el.__rehighlight__()
        }
      },

      update(el, binding) {
        // обновляем query и набор селекторов
        const prevQ = el.__hl__.lastQuery
        const prevSel = (el.__hl__.selectors || []).join(',')

        let nextQ = ''
        let nextSelArr = null

        if (typeof binding.value === 'string') {
          nextQ = binding.value
        } else if (binding.value && typeof binding.value === 'object') {
          nextQ = binding.value.query || ''
          const norm = (val) => {
            if (!val) return null
            let list = Array.isArray(val) ? val : String(val).split(',')
            list = list.map(s => s.trim()).filter(Boolean)
            return list.map(s => (s.startsWith('.') || /[#>\[\]\s:]/.test(s) ? s : `.${s}`))
          }
          nextSelArr = norm(binding.value.classes || binding.value.within || binding.value.targets)
        }

        const nextSel = (nextSelArr || []).join(',')

        if (nextQ !== prevQ || nextSel !== prevSel) {
          el.__hl__.lastQuery = nextQ
          el.__hl__.selectors = nextSelArr
          el.__rehighlight__()
        }
      },

      componentUpdated(el) {
        el.__rehighlight__()
      },

      unbind(el) {
        el.__observer__.disconnect()
        el.__clearHighlights__()
        delete el.__observer__
        delete el.__rehighlight__
        delete el.__applyHighlights__
        delete el.__clearHighlights__
        delete el.__hl__
        delete el.__initialBinding__
      }
    }
  },
}
</script>

<style>
.hm-dashboard__top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
}

.hm-dashboard__header {
  display: grid;
  grid-template-columns: 1fr 300px;
  align-items: center;
  gap: 50px;
}

.hm-dashboard__title {
  flex-shrink: 0;
  display: flex;
  gap: 15px;
  color: #000;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 23px;
  font-weight: 600;
  line-height: 1.15;
}

.hm-dashboard__title-date {
  font-weight: 400;
}

.hm-dashboard__controls {
  display: flex;
  gap: 20px;
  margin-bottom: 50px;
}

.hm-dashboard__control {
  padding: 15px;
  border-radius: 17px;
  border: 1px solid #ECEAE5;
  background-color: #FCFCFC;
  box-shadow: 0 1px 5px 0 rgba(159, 167, 177, 0.20);
  transition: border-color 0.3s, opacity 0.3s;
  user-select: none;

  &:hover {
    border-color: #A3A3A3;
  }
}

.hm-dashboard__control--disabled {
  pointer-events: none;
  opacity: 0.5;
}

.hm-dashboard__control--active {
  border-color: #A3A3A3;
}

.hm-dashboard__control-top {
  display: flex;
  align-items: center;
  gap: 10px;
}

.hm-dashboard__control-text {
  color: #76A9B4;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.2;
}

.hm-dashboard__line {
  display: grid;
  grid-template-columns: 1fr 130px 150px;
  align-items: center;
}

.hm-dashboard__line-left {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.hm-dashboard__grid {
  display: grid;
  grid-template-columns: minmax(120px, 0.5fr) 150px minmax(170px, 200px) minmax(250px, 1fr);
  align-items: center;
  gap: 50px;
  padding-left: 30px;
}

.hm-dashboard__grid-head {
  color: #666;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
}

.hm-dashboard__hit {
  background-color: #E8D17E;
}
</style>
